import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { format } from '../../lib/money';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  slotsText: {
    id: 'shareInfo.locked.slotsText',
    defaultMessage: '{amount} ({slots} {slotsName})',
  },
  slotsText_adult: {
    id: 'shareInfo.locked.slotsText_adult',
    defaultMessage: '{amount} ({slots} adults)',
  },
  slotsText_passenger: {
    id: 'shareInfo.locked.slotsText_passenger',
    defaultMessage: '{amount} ({slots} passengers)',
  },
  slotsText_ticket: {
    id: 'shareInfo.locked.slotsText_ticket',
    defaultMessage: '{amount} ({slots} tickets)',
  },
  slotsText_seat: {
    id: 'shareInfo.locked.slotsText_seat',
    defaultMessage: '{amount} ({slots} seats)',
  },
  slotsText_item: {
    id: 'shareInfo.locked.slotsText_item',
    defaultMessage: '{amount} ({slots} items)',
  },
  slotsText_shirt: {
    id: 'shareInfo.locked.slotsText_shirt',
    defaultMessage: '{amount} ({slots} shirts)',
  },
  slotsText_person: {
    id: 'shareInfo.locked.slotsText_person',
    defaultMessage: '{amount} ({slots} people)',
  },
  slotsText_guest: {
    id: 'shareInfo.locked.slotsText_guest',
    defaultMessage: '{amount} ({slots} guests)',
  },
  slotsText_player: {
    id: 'shareInfo.locked.slotsText_player',
    defaultMessage: '{amount} ({slots} players)',
  },
  slotsText_student: {
    id: 'shareInfo.locked.slotsText_student',
    defaultMessage: '{amount} ({slots} students)',
  },
  none: {
    id: 'shareInfo.locked.none',
    defaultMessage: 'none',
  },
});

class ShareInfo extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }

  renderSlotsText() {
    const { slotsClaimed, maxAmount, purchase } = this.props;

    if (slotsClaimed === 0 || !maxAmount) {
      return this.formatMessage(i18n.none);
    }

    if (slotsClaimed === 1) {
      return format(maxAmount);
    }

    return this.formatMessage(i18n.slotsText, { amount: format(maxAmount), slots: slotsClaimed }, purchase.slotName);
  }

  render() {
    return (
      <div className="split-info even-split h3 mr-1 mb-0 mb-2">
        <FormattedMessage
          id="shareInfo.locked.readyToContribute"
          defaultMessage="Ready to contribute for"
        />
        {' '}
        <strong>{this.renderSlotsText()}</strong>
      </div>
    );
  }
}

ShareInfo.defaultProps = {
  maxAmount: null,
  slotsClaimed: 1,
  purchase: null,
};

export default injectIntl(ShareInfo);




// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/share-info.locked.js